//スライダー
$(function() {
	$('.slick').slick({
        autoplay: true,
        autoplaySpeed: 3000,
		speed: 500,
		slidesToShow: 3,
    	slidesToScroll: 1,
        dots: false,
        arrows: false,
		swipe: false,
        centerMode: true,
        centerPadding: '0%',
        focusOnSelect: false,
        pauseOnHover: false,
        pauseOnFocus: false,
		cssEase: 'linear',
		infinite: true,
        responsive: [{
                breakpoint: 780,
                settings: {
                    centerPadding: '0%',
                }
            },
            {
                breakpoint: 480,
                settings: {
                    centerPadding: '0%',
                }
            },
        ]
    });
});


//スマホでautoplayが止まる対策
$(function() {
    $('.slick').on('touchmove', function(event, slick, currentSlide, nextSlide){
    $('.slick').slick('slickPlay');
  });
});  
